import React, { useEffect, useState } from "react";
import { TextField, Checkbox, FormControlLabel, Button, Box, Typography } from "@mui/material";
import { Grid2 as Grid } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const SearchBox = ({ filters, setFilters, onSearch }) => {
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    // 対応状況ステータス一覧
    const getStatusOptions = async () => {
      const options = [
        { id: "対応中", name: "対応中" },
        { id: "完了", name: "完了" },
        { id: "途中終了", name: "途中終了" }
      ];
      setStatusOptions(options);
    };
    getStatusOptions();
  }, []);

  return (
    <Box p={2} border="none" borderRadius={2} borderColor="grey.300">
      <Typography variant="h6">検索</Typography>
      <TextField
        label="地震名称"
        variant="outlined"
        fullWidth
        margin="dense"
        value={filters.name}
        onChange={(e) => setFilters({ ...filters, name: e.target.value })}
        sx={{ marginBottom: 4, backgroundColor: "white" }}
      />
      <Typography variant="body1" sx={{ marginBottom: 1, fontWeight: "bold" }}>対応状況</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: 4 }}>
        {statusOptions.map((row, index) => (
          <FormControlLabel
            key={row.id}
            control={
              <Checkbox
                checked={filters.status.includes(row.id)}
                onChange={(e) => {
                  const newStatus = e.target.checked
                    ? [...filters.status, row.id]
                    : filters.status.filter((s) => s !== row.id);
                  setFilters({ ...filters, status: newStatus });
                }}
                sx={{
                  '& .MuiSvgIcon-root': { fontSize: 20 },
                }}
              />
            }
            label={row.name}
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: '14px',
                fontWeight: 'bold',
              },
            }}
          />
        ))}
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ marginBottom: 2, fontWeight: "bold" }}>地震発生日</Typography>
        <Grid container spacing={2}>
          {/* 開始日 */}
          <Grid size={12}>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="開始日"
                value={filters.startDate}
                onChange={(date) => setFilters({ ...filters, startDate: date })}
                // renderInput={(params) => <TextField {...params} fullWidth margin="dense" />}
                sx={{ backgroundColor: "white" }}
                format="YYYY/MM/DD"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: "dense",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          {/* 終了日 */}
          <Grid size={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="終了日"
                value={filters.endDate}
                onChange={(date) => setFilters({ ...filters, endDate: date })}
                // renderInput={(params) => <TextField {...params} fullWidth margin="dense" />}
                sx={{ backgroundColor: "white" }}
                format="YYYY/MM/DD"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    margin: "dense",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
      </Box>
      <Button variant="contained" fullWidth onClick={onSearch} sx={{ mt: 2 }}>検索</Button>
    </Box>
  );
};

export default SearchBox;
